import React from 'react';
import { Navigate } from 'react-router-dom';

// Dummy authentication check (replace with real logic)
const isAuthenticated = () => {
  return !!localStorage.getItem('admin_token');
};

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
